
















import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class SubcategoryColorIcon extends Vue {
  @Prop() private id!: string;
  @Prop({ default: "24px" }) private size?: string;
  @Prop({ default: "#FFFFFF" }) private color?: string;
}
